const devDomains = [
    'agreeable-ocean-023c91300.3.azurestaticapps.net',
    'kuggar-dev-au-web-cp.azurewebsites.net',
    'kuggar-dev-fr-web-cp.azurewebsites.net',
    'portal.dev.au.kuggar.io',
    'portal.dev.fr.kuggar.io',
    'share.dev.kuggar.io',
    'icy-mud-0299b8d00.6.azurestaticapps.net'
];

const devMintDomains = [
    'portal.dev.mint.kuggar.io'
];

const devUatpDomains = [
    'portal.dev.vc.uatp.com'
];

const testDomains = [
    'kuggar-test-web-cp.azurefd.net',
    'portal.test.kuggar.io'
];

const stagingDomains = [
    'black-forest-0ea77aa03.1.azurestaticapps.net',
    'portal.staging.kuggar.io',
    'share.staging.kuggar.io'
];

const testAUAzureDomains = [
    'kuggar-test-au-web-cp.azurewebsites.net',
    'portal.test.au.kuggar.io'
];

const testAUAWSDomains = [
    'dg08jklimtv7d.cloudfront.net',
    'portal.aws.test.au.kuggar.io'
];

const testAEAzureDomains = [
    'kuggar-test-ae-web-cp.azurewebsites.net',
    'portal.test.ae.kuggar.io'
];

const testMintDomains = [
    'virtualcard-staging.mintpayments.com'
];

const testUatpDomains = [
    'portal.staging.vc.uatp.com'
];

const prodDomains = [
    'ambitious-bush-0f1487400.1.azurestaticapps.net',
    'portal.kuggar.io',
    'share.kuggar.io',
    'supplyvcc.flightcentre.com'
];

const prodMintDomains = [
    'virtualcard.mintpayments.com'
];

const prodUatpDomains = [
    'portal.vc.uatp.com'
];

const domain = window.location.host;

let BaseUrl = ""
if (prodDomains.includes(domain)) {
    BaseUrl = 'https://virtualcards.az.gb.kuggar.io/api/v2';
} else if (prodMintDomains.includes(domain)) {
    BaseUrl = 'https://virtualcards.az.gb.kuggar.io/api/v2';
} else if (prodUatpDomains.includes(domain)) {
    BaseUrl = 'https://virtualcards.az.gb.kuggar.io/api/v2';
} else if (testAUAzureDomains.includes(domain)) {
    BaseUrl = 'https://virtualcards.test.au.kuggar.io/api/v1';
} else if (testAUAWSDomains.includes(domain)) {
    BaseUrl = 'https://virtualcards.aws.test.au.kuggar.io/api/v1';
} else if (testAEAzureDomains.includes(domain)) {
    BaseUrl = 'https://virtualcards.test.ae.kuggar.io/api/v1';
} else if (stagingDomains.includes(domain)) {
    BaseUrl = 'https://virtualcards.az.staging.au.kuggar.io/api/v2';
} else if (testDomains.includes(domain)) {
    BaseUrl = 'https://virtualcards.test.kuggar.io/api/v1';
} else if (testMintDomains.includes(domain)) {
    BaseUrl = 'https://virtualcards.az.staging.au.kuggar.io/api/v2';
} else if (testUatpDomains.includes(domain)) {
    BaseUrl = 'https://virtualcards.az.staging.au.kuggar.io/api/v2';
} else if (devDomains.includes(domain)) {
    BaseUrl = 'https://virtualcards.az.dev.au.kuggar.io/api/v2';
} else if (devMintDomains.includes(domain)) {
    BaseUrl = 'https://virtualcards.az.dev.au.kuggar.io/api/v2';
} else if (devUatpDomains.includes(domain)) {
    BaseUrl = 'https://virtualcards.az.dev.au.kuggar.io/api/v2';
} else {
    BaseUrl = 'https://localhost:7006/api/v2';
}

export default BaseUrl;